import React from "react";
import { Link } from "react-router-dom";

/**
 * The one button (audit 7.4).
 * variant: primary | secondary (outline) | ghost | danger     size: sm | md
 * loading shows the single shared button spinner and disables the button.
 */
export default function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  block = false,
  to,
  href,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const cls = [
    "ee-btn",
    `ee-btn--${variant}`,
    `ee-btn--${size}`,
    block ? "ee-btn--block" : "",
    loading ? "is-loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      {loading ? <span className="ee-btn__spinner" aria-hidden="true" /> : null}
      <span className="ee-btn__label">{children}</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} className={cls} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {content}
    </button>
  );
}
